import {observer} from 'mobx-react-lite';
import React from 'react';

import contactsHandledBackend, {
  ContactWithInvolvements,
} from '@lexian/api/contacts-api';
import {EFAutocompleteProps} from '_/utilities/form';

import {ContactAutocomplete} from './ContactAutocomplete';
import {
  ContactAutocompleteProps,
  SearchContactsWithInvolvementsProps,
} from './types';
import {CONTACT_CATEGORIES, mapContactToOption} from './utils';

type CasusContactAutocompleteExtraParams = Pick<
  Parameters<
    typeof contactsHandledBackend.searchContactsWithInvolvements
  >[0]['parameters'],
  'casusId' | 'excludeIds' | 'excludeInvolvementTypes' | 'involvementOrder'
>;

type CasusContactAutocompleteProps = SearchContactsWithInvolvementsProps &
  Omit<EFAutocompleteProps, 'options' | 'categories'> &
  Omit<
    ContactAutocompleteProps<
      ContactWithInvolvements,
      CasusContactAutocompleteExtraParams
    >,
    'loadContactCall' | 'mapToOptions'
  >;

const UCasusContactAutocomplete = ({
  casusId,
  involvementOrder,
  excludeInvolvementTypes,
  alreadySelectedOptions,
  ...props
}: CasusContactAutocompleteProps): React.ReactElement => (
  <ContactAutocomplete
    categories={CONTACT_CATEGORIES}
    loadContactCall={contactsHandledBackend.searchContactsWithInvolvements}
    loadContactCallInitialExtraParams={{
      casusId,
      involvementOrder,
      excludeInvolvementTypes,
      excludeIds: alreadySelectedOptions,
    }}
    mapToOptions={mapContactToOption}
    {...props}
  />
);
export const CasusContactAutocomplete = observer(UCasusContactAutocomplete);
